import { atom } from 'recoil'
import { TravelDetailResponse } from '../repository/travel.repository'

export const myTravelState = atom<TravelDetailResponse>({
  key: 'myTravelState',
  default: { companion: '', spots: [], startAt: '', themes: {}, title: '', place: '' },
})
